module.exports = __webpack_public_path__ + "static/img/MK.b3b9577f.svg";